import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'

import { toSearchString } from '../utils/common'

interface LocationParams {
  [key: string]: string | number | boolean | null | undefined
}

export function useLocationParams() {
  const navigate = useNavigate()
  const { hash, pathname, search } = useLocation()

  function updateLocationParams(params: LocationParams) {
    navigate({
      hash,
      pathname,
      search: toSearchString({
        ...queryString.parse(search),
        ...params,
      }),
    })
  }

  function setLocationParams(params: LocationParams) {
    navigate({
      hash,
      pathname,
      search: toSearchString(params),
    })
  }

  return useMemo(
    () => ({
      locationParams: queryString.parse(search),
      updateLocationParams,
      setLocationParams,
    }),
    [hash, navigate, pathname, search]
  )
}
